export default {
    items: [
        { name: "Github", file: "github", link: "https://www.github.com/QxBytes" },
        { name: "Linkedin", file: "linkedin", link: "https://www.linkedin.com/in/alexander-58727121a" }
    ]
}